import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LoggerService } from '@app/services/logger.service';
import { AdminRoleCondition, PermHelperService } from '@app/services/perm-helper.service';
import { ControlPageFacade } from '@ra-state';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly permissionHelper = inject(PermHelperService);
  private readonly controlPageFacade = inject(ControlPageFacade);

  logger = inject(LoggerService).withContext(RoleGuard);
  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const requiredRoles = route.data['requiredRoles'] as AdminRoleCondition;
    this.logger.debug('Required Roles', requiredRoles);
    return this.permissionHelper.checkRoles$(requiredRoles).pipe(
      map((hasAccess) => {
        if (hasAccess) {
          return true;
        }
        const requiresHomeRedirect = this.router.url === '/' || this.router.url === '';
        const errorMessage = requiresHomeRedirect
          ? 'Insufficient Permissions. Redirecting to Home page.'
          : 'Insufficient Permissions.';
        this.controlPageFacade.setPermissionDenied(errorMessage, () => {
          if (requiresHomeRedirect) {
            this.router.navigate(['/home']);
          }
        });
        return false;
      }),
    );
  }
}
